import { confirm, message } from '@/utils/tools';
import { getRuntimeEnv, isInnerEnv } from './env';

const GlobalVariablePlugin = {
  install(app) {
    app.provide('$confirm', confirm);
    app.provide('$message', message);
    app.config.globalProperties.$env = getRuntimeEnv();
    app.config.globalProperties.$confirm = confirm;
    app.config.globalProperties.$isInnerEnv = isInnerEnv;
  },
};

export default GlobalVariablePlugin;
